import api from "../api/flexapi";
export const SUBMIT_CHARITY_SURVEY_BEGIN = "SUBMIT_CHARITY_SURVEY_BEGIN";
export const SUBMIT_CHARITY_SURVEY_SUCCESS = "SUBMIT_CHARITY_SURVEY_SUCCESS";
export const SUBMIT_CHARITY_SURVEY_ERROR = "SUBMIT_CHARITY_SURVEY_ERROR";

export const submitCharitySurvey = answers => dispatch => {
  dispatch({ type: SUBMIT_CHARITY_SURVEY_BEGIN, payload: null });
  api
    .postCharitySurvey(answers)
    .then(() => {
      dispatch({
        type: SUBMIT_CHARITY_SURVEY_SUCCESS,
        payload: null,
      });
    })
    .catch(err => {
      dispatch({
        type: SUBMIT_CHARITY_SURVEY_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};



// WEBPACK FOOTER //
// ./actions/charityActions.js